import { Sparkles, X } from "lucide-react";
import { useState } from "react";
import { Heart } from "./Illustrations";

export default function AnnouncementBar() {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  const scrollToContact = () => {
    const el = document.getElementById("epikoinonia");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div
      data-testid="announcement-bar"
      className="relative bg-gradient-to-r from-brand-pink via-brand-yellow to-brand-secondary text-brand-text"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-center gap-3 text-center">
        <Heart size={18} className="flex-shrink-0 hidden sm:block animate-pulse-soft" />
        <p className="font-body text-xs sm:text-sm font-bold">
          Προσφέρουμε{" "}
          <span className="font-heading font-bold text-brand-primaryHover">
            ΔΩΡΕΑΝ Αξιολόγηση
          </span>{" "}
          για κάθε παιδί —{" "}
          <button
            onClick={scrollToContact}
            data-testid="announcement-cta"
            className="font-bold underline decoration-wavy decoration-2 underline-offset-2 hover:text-brand-primaryHover transition-colors"
          >
            Κλείστε ραντεβού
          </button>
        </p>
        <button
          onClick={() => setOpen(false)}
          aria-label="Κλείσιμο"
          data-testid="announcement-close"
          className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full hover:bg-white/30 flex items-center justify-center transition-colors"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
